var path = 'app/scripts/modules/core/src/pipeline/config/preconditions/selector/preconditionSelector.html';
var html = "<div class=\"form-group row\">\n  <div class=\"col-sm-3 sm-label-right\" id=\"type\">Check</div>\n  <div class=\"col-sm-9\">\n    <select class=\"input-sm\"\n            ng-options=\"t.key as t.label for t in preconditionTypes\"\n            ng-model=\"precondition.type\"\n            ng-change=\"preconditionCtrl.clearContext()\">\n    </select>\n  </div>\n</div>\n<div ng-include=\"preconditionCtrl.getPreconditionContextTemplateUrl()\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/preconditions/selector/preconditionSelector.html
// module id = 1069
// module chunks = 0